export default {"src":"/_next/static/media/RightArrowBlack.b1ccf6aa.svg","height":12,"width":7,"blurWidth":0,"blurHeight":0};